/* eslint-disable @next/next/no-img-element */
import { useAmp } from 'next/amp';
import React, { useEffect, useState } from 'react';

function SidebarContent({ importPrefix, onChange }) {
  const isAmp = useAmp();
  const [opened, setOpened] = useState(null);

  const getClass = (className = '', index) => {
    if (isAmp) return '';
    const isOpened = index === opened ? ' opened' : '';

    return className + isOpened;
  };

  useEffect(() => {
    if (onChange) {
      onChange(opened);
    }
  }, [opened, onChange]);

  return (
    <ul className="sidebar-wrapper">
      <li>
        <div
          amp-nested-submenu-open=""
          onClick={(ev) => {
            ev.preventDefault();
            setOpened(0);
          }}
          className="sidebar-item-container"
        >
          <span>Meu financiamento</span>
          {isAmp && (
            <amp-img
              src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
              alt="Ícone de seta para a direita"
              layout="fixed"
              height="16"
              width="16"
              class="arrow"
            />
          )}
          {!isAmp && (
            <img
              src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
              alt="Ícone de seta para a direita"
              height="16"
              width="16"
              className="arrow"
            />
          )}
        </div>
        <div amp-nested-submenu="" className={getClass('nested-submenu-ampless', 0)}>
          <ul className="sidebar-wrapper sub-sidebar ">
            <li>
              <div
                amp-nested-submenu-close=""
                onClick={(ev) => {
                  ev.preventDefault();
                  setOpened(null);
                }}
                className="sidebar-item-container justify-start go-back"
              >
                {isAmp && (
                  <amp-img
                    src={`${importPrefix}static/amp/shared/assets/ic_arrow_l.svg`}
                    alt="Ícone de seta para a esquerda"
                    layout="fixed"
                    height="16"
                    width="16"
                    class="arrow"
                  />
                )}
                {!isAmp && (
                  <img
                    src={`${importPrefix}static/amp/shared/assets/ic_arrow_l.svg`}
                    alt="Ícone de seta para a esquerda"
                    height="16"
                    width="16"
                    className="arrow"
                  />
                )}
                <span>Voltar</span>
              </div>
            </li>

            <li>
              <p>Boletos</p>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a href={`${importPrefix}boleto.html`} id="segunda-via-de-boletos-menu-mobile">
                  2ª via de boletos
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href={`${importPrefix}renegociacao-santander-financiamentos.html`}
                  id="renegociacao-menu-mobile"
                >
                  Renegociação
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF"
                  target="_blank"
                  rel="noopener"
                  id="boleto-vencido-menu-mobile"
                >
                  Boleto Vencido
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:menu-meu-dia-a-dia&int_campaign=comprovantes"
                  target="_blank"
                  rel="noopener"
                  id="comprovantes-menu-mobile"
                >
                  Comprovantes
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <p>Soluções</p>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href={`${importPrefix}consultar-financiamento.html`}
                  id="consultar-financiamento-menu-mobile"
                >
                  Consultar Financiamento
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <p>Contratos</p>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:menu-meu-dia-a-dia&int_campaign=resumo-copia-de-contrato"
                  target="_blank"
                  rel="noopener"
                  id="resumo-e-ou-copia-de-contrato-menu-mobile"
                >
                  Resumo e/ou cópia de contrato
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:menu-meu-dia-a-dia&int_campaign=transferencia-de-financiamento"
                  target="_blank"
                  rel="noopener"
                  id="trasnferencia-de-financiamento-menu-mobile"
                >
                  Transferência de financiamento
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </li>
      <li>
        <div
          amp-nested-submenu-open=""
          className="sidebar-item-container"
          onClick={(ev) => {
            ev.preventDefault();
            setOpened(1);
          }}
        >
          <span>Produtos</span>
          {isAmp && (
            <amp-img
              src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
              alt="Ícone de seta para a direita"
              layout="fixed"
              height="16"
              width="16"
              class="arrow"
            />
          )}
          {!isAmp && (
            <img
              src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
              alt="Ícone de seta para a direita"
              height="16"
              width="16"
              className="arrow"
            />
          )}
        </div>
        <div amp-nested-submenu="" className={getClass('nested-submenu-ampless', 1)}>
          <ul className="sidebar-wrapper sub-sidebar">
            <li>
              <div
                amp-nested-submenu-close=""
                onClick={(ev) => {
                  ev.preventDefault();
                  setOpened(null);
                }}
                className="sidebar-item-container justify-start go-back"
              >
                {isAmp && (
                  <amp-img
                    src={`${importPrefix}static/amp/shared/assets/ic_arrow_l.svg`}
                    alt="Ícone de seta para a esquerda"
                    layout="fixed"
                    height="16"
                    width="16"
                    class="arrow"
                  />
                )}
                {!isAmp && (
                  <img
                    src={`${importPrefix}static/amp/shared/assets/ic_arrow_l.svg`}
                    alt="Ícone de seta para a esquerda"
                    height="16"
                    width="16"
                    className="arrow"
                  />
                )}
                <span>Voltar</span>
              </div>
            </li>

            <li>
              <p>Produtos</p>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?ori=SF&int_source=menu-simule-ja#/simulacao"
                  target="_blank"
                  rel="noopener"
                  id="simule-ja-menu-mobile"
                  className="text-red"
                >
                  Simular Financiamento
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href={`${importPrefix}banco-do-auto.html`}
                  id="financiamento-de-veiculo-menu-mobile"
                >
                  Financiamento de veículos
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href={`${importPrefix}financiamento-de-motos.html`}
                  id="financiamento-de-motos-menu-mobile"
                >
                  Financiamento de motos
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href={`${importPrefix}financiar-veiculos-eletricos.html`}
                  id="veiculos-eletricos-menu-mobile"
                >
                  Veículos elétricos
                  {/* <div className="flag-destaque">Até 25% OFF</div> */}
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href={`${importPrefix}energia-solar-fotovoltaica.html`}
                  id="energia-solar-menu-mobile"
                >
                  Energia Solar
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href={`${importPrefix}emprestimo-garantia-carro.html`}
                  id="emprestimo-com-garantia-de-veiculo-menu-mobile"
                >
                  Empréstimo com Garantia de Veículo
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href={`${importPrefix}parcelamento-bens-servicos.html`}
                  id="parcelamento-de-bens-e-servicos-menu-mobile"
                >
                  Parcelamento de bens e serviços
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href={`${importPrefix}seguro-santander-auto.html`}
                  id="seguro-santander-auto-menu-mobile"
                >
                  Seguros Santander
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href={`${importPrefix}leilao-de-veiculos.html`}
                  id="leilao-de-veiculos-menu-mobile"
                >
                  Leilão de veículos
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a href={`${importPrefix}car10.html`} id="servicos-automotivos-menu-mobile">
                  Serviços Automotivos
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </li>

      <li>
        <div className="sidebar-item-container">
          <a href={`${importPrefix}open-finance.html`} id="open-finance-menu-mobile">
            Open Finance
          </a>
          {isAmp && (
            <amp-img
              src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
              alt="Ícone de seta para a direita"
              layout="fixed"
              height="16"
              width="16"
              class="arrow"
            />
          )}
          {!isAmp && (
            <img
              src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
              alt="Ícone de seta para a direita"
              height="16"
              width="16"
              className="arrow"
            />
          )}
        </div>
      </li>

      <li>
        <div className="sidebar-item-container">
          <a href={`${importPrefix}credenciados.html`} id="lojas-credenciadas-menu-mobile">
            Lojas Credenciadas
          </a>
          {isAmp && (
            <amp-img
              src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
              alt="Ícone de seta para a direita"
              layout="fixed"
              height="16"
              width="16"
              class="arrow"
            />
          )}
          {!isAmp && (
            <img
              src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
              alt="Ícone de seta para a direita"
              height="16"
              width="16"
              className="arrow"
            />
          )}
        </div>
      </li>

      <li>
        <div className="sidebar-item-container">
          <a href={`${importPrefix}blog.html`} id="blog-menu-mobile">
            Blog
          </a>
          {isAmp && (
            <amp-img
              src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
              alt="Ícone de seta para a direita"
              layout="fixed"
              height="16"
              width="16"
              class="arrow"
            />
          )}
          {!isAmp && (
            <img
              src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
              alt="Ícone de seta para a direita"
              height="16"
              width="16"
              className="arrow"
            />
          )}
        </div>
      </li>

      <li>
        <div
          amp-nested-submenu-open=""
          className="sidebar-item-container"
          onClick={(ev) => {
            ev.preventDefault();
            setOpened(2);
          }}
        >
          <span>Ajuda</span>
          {isAmp && (
            <amp-img
              src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
              alt="Ícone de seta para a direita"
              layout="fixed"
              height="16"
              width="16"
              class="arrow"
            />
          )}
          {!isAmp && (
            <img
              src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
              alt="Ícone de seta para a direita"
              height="16"
              width="16"
              className="arrow"
            />
          )}
        </div>
        <div amp-nested-submenu="" className={getClass('nested-submenu-ampless', 2)}>
          <ul className="sidebar-wrapper sub-sidebar">
            <li>
              <div
                amp-nested-submenu-close=""
                onClick={(ev) => {
                  ev.preventDefault();
                  setOpened(null);
                }}
                className="sidebar-item-container justify-start go-back"
              >
                {isAmp && (
                  <amp-img
                    src={`${importPrefix}static/amp/shared/assets/ic_arrow_l.svg`}
                    alt="Ícone de seta para a esquerda"
                    layout="fixed"
                    height="16"
                    width="16"
                    class="arrow"
                  />
                )}
                {!isAmp && (
                  <img
                    src={`${importPrefix}static/amp/shared/assets/ic_arrow_l.svg`}
                    alt="Ícone de seta para a esquerda"
                    height="16"
                    width="16"
                    className="arrow"
                  />
                )}
                <span>Voltar</span>
              </div>
            </li>

            <li>
              <p>Ajuda</p>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href={`${importPrefix}canais-de-atendimento.html`}
                  id="central-de-atendimento-menu-mobile"
                >
                  Canais de atendimento
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href={`${importPrefix}duvidas-frequentes.html`}
                  id="duvidas-frequentes-menu-mobile"
                >
                  Dúvidas frequentes
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a href={`${importPrefix}denuncias-e-fraudes.html`} id="fraudes-menu-mobile">
                  Fraudes
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href={`${importPrefix}politica-de-privacidade.html`}
                  id="privacidade-e-seguranca-menu-mobile"
                >
                  Privacidade e segurança
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>

            <li>
              <div className="sidebar-item-container">
                <a
                  href="https://www.santander.com.br/educacao-financeira"
                  target="_blank"
                  rel="noopener"
                  id="orientacao-financeira-menu-mobile"
                >
                  Orientação financeira
                  {isAmp && (
                    <amp-img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      layout="fixed"
                      height="16"
                      width="16"
                      class="arrow"
                    />
                  )}
                  {!isAmp && (
                    <img
                      src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
                      alt="Ícone de seta para a direita"
                      height="16"
                      width="16"
                      className="arrow"
                    />
                  )}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  );
}

export default SidebarContent;
